import { createContext, useContext, useState, useCallback } from "react";
import { toast } from "sonner";

const CompareContext = createContext(null);

export const MAX_COMPARE = 3;

export const CompareProvider = ({ children }) => {
  const [items, setItems] = useState([]);
  const [open, setOpen] = useState(false);

  const isIn = useCallback((slug) => items.some((t) => t.slug === slug), [items]);

  const toggle = useCallback(
    (tour) => {
      setItems((prev) => {
        if (prev.some((t) => t.slug === tour.slug)) {
          return prev.filter((t) => t.slug !== tour.slug);
        }
        if (prev.length >= MAX_COMPARE) {
          toast.error(`You can compare up to ${MAX_COMPARE} tours. Remove one to add another.`);
          return prev;
        }
        toast.success(`Added "${tour.title}" to compare`);
        return [...prev, tour];
      });
    },
    []
  );

  const remove = useCallback((slug) => setItems((prev) => prev.filter((t) => t.slug !== slug)), []);
  const clear = useCallback(() => { setItems([]); setOpen(false); }, []);

  return (
    <CompareContext.Provider value={{ items, isIn, toggle, remove, clear, open, setOpen }}>
      {children}
    </CompareContext.Provider>
  );
};

export const useCompare = () => {
  const ctx = useContext(CompareContext);
  if (!ctx) throw new Error("useCompare must be used within CompareProvider");
  return ctx;
};
